import React from 'react';

export type CategorySlug =
  | 'top-headlines' |'world-politics' |'technology' |'business' |'science' |'sports' |'breaking';

interface CategoryBadgeProps {
  category: CategorySlug;
  size?: 'sm' | 'md';
  className?: string;
}

const CATEGORY_CONFIG: Record<
  CategorySlug,
  { label: string; bg: string; text: string; dot: string }
> = {
  'top-headlines': {
    label: 'Top Headlines',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    dot: 'bg-blue-500',
  },
  'world-politics': {
    label: 'World Politics',
    bg: 'bg-red-50',
    text: 'text-red-700',
    dot: 'bg-red-500',
  },
  technology: {
    label: 'Technology',
    bg: 'bg-violet-50',
    text: 'text-violet-700',
    dot: 'bg-violet-500',
  },
  business: {
    label: 'Business & Finance',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    dot: 'bg-amber-500',
  },
  science: {
    label: 'Science',
    bg: 'bg-cyan-50',
    text: 'text-cyan-700',
    dot: 'bg-cyan-500',
  },
  sports: {
    label: 'Sports',
    bg: 'bg-green-50',
    text: 'text-green-700',
    dot: 'bg-green-500',
  },
  breaking: {
    label: 'Breaking',
    bg: 'bg-red-600',
    text: 'text-white',
    dot: 'bg-white',
  },
};

export default function CategoryBadge({
  category,
  size = 'sm',
  className = '',
}: CategoryBadgeProps) {
  const config = CATEGORY_CONFIG[category] ?? CATEGORY_CONFIG['top-headlines'];
  return (
    <span data-component-id="src/components/CategoryBadge.tsx:67:4" data-component-path="src/components/CategoryBadge.tsx" data-component-line="67" data-component-end-line="74" data-component-file="CategoryBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`inline-flex items-center gap-1.5 rounded-full font-medium tracking-wide uppercase
        ${size === 'sm' ? 'px-2.5 py-0.5 text-[10px]' : 'px-3 py-1 text-xs'}
        ${config.bg} ${config.text} ${className}`}
    >
      <span data-component-id="src/components/CategoryBadge.tsx:72:6" data-component-path="src/components/CategoryBadge.tsx" data-component-line="72" data-component-end-line="72" data-component-file="CategoryBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`w-1.5 h-1.5 rounded-full shrink-0 ${config.dot}`} />
      {config.label}
    </span>
  );
}

export { CATEGORY_CONFIG };